import { css } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { useTheme } from '../../theme'

import getStyles from './styles'

import SortDown from './sort-down.svg'
import SortUp from './sort-up.svg'
import Sort from './sort.svg'

interface ISortingIconProps {
  value?: 'asc' | 'desc'
}

/**
 * @type {React.StatelessComponent}
 */
const SortingIcon = ({ value }: ISortingIconProps) => {
  const theme = useTheme()
  const styles = getStyles(theme)
  if (value === 'asc') {
    return (
      <i {...css(styles.icon.base)}>
        <SortUp fill={theme.colors.accents.secondaryHover} />
      </i>
    )
  }

  if (value === 'desc') {
    return (
      <i {...css(styles.icon.base)}>
        <SortDown fill={theme.colors.accents.secondaryHover} />
      </i>
    )
  }

  return (
    <i {...css(styles.icon.base)}>
      <Sort fill={theme.colors.accents.secondaryHover} />
    </i>
  )
}

SortingIcon.propTypes = {
  value: PropTypes.oneOf(['asc', 'desc']),
}

interface ISortableProps {
  value: 'desc' | 'asc'
  onClick?: (e: React.SyntheticEvent) => void
  children: React.ReactNode
}

/**
 * @type {React.StatelessComponent}
 */
export const Sortable = ({ value, children, onClick }: ISortableProps) => {
  const active = Boolean(value)
  const styles = getStyles(useTheme())

  return (
    <span
      onClick={event => onClick && onClick(event)}
      onKeyPress={event => onClick && (event.key === 'Enter' || event.key === ' ') && onClick(event)}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      {...css([styles.sortable.base, onClick && styles.sortable.clickable, active && styles.sortable.active])}
    >
      {children} <SortingIcon value={value} />
    </span>
  )
}

Sortable.propTypes = {
  value: PropTypes.oneOf(['desc', 'asc']),
  onClick: PropTypes.func,
  children: PropTypes.node,
}
